import React from 'react';
import './Gallery.css';

export function Gallery() {
  const images = [
    { src: 'g_real_1.webp', alt: 'Real packed boxes loaded inside moving truck container - Neha Packers & Movers' },
    { src: 'g_real_2.webp', alt: 'Furniture and chairs carefully bubble wrapped - Neha Packers & Movers' },
    { src: 'g_real_3.webp', alt: 'Large household cabinet wrapped in plastic stretch film - Neha Packers & Movers' },
    { src: 'g_real_4.webp', alt: 'Premium living room furniture wrapped and ready for shifting - Neha Packers & Movers' },
    { src: 'g_real_5.webp', alt: 'Packed cargo ready for loading in room - Neha Packers & Movers' },
    { src: 'p1.webp', alt: 'Office shifting files and storage packaging - Neha Packers & Movers' },
    { src: 'p2.webp', alt: 'Residential moving loading boxes inside truck - Neha Packers & Movers' },
    { src: 'p3.webp', alt: 'Technicians wrapping appliances and bubble wrapping household items - Neha Packers & Movers' },
    { src: 'p4.webp', alt: 'Safely loaded shifting packages in moving truck - Neha Packers & Movers' },
    { src: 'p5.webp', alt: 'Movers carrying cardboard boxes for office shifting - Neha Packers & Movers' },
    { src: 'p6.webp', alt: 'Movers loading furniture in warehouse storage facility - Neha Packers & Movers' },
    { src: 'p7.webp', alt: 'Household shifting packing materials and boxes - Neha Packers & Movers' },
    { src: 'p8.webp', alt: 'Professional vehicle transport carrier loading - Neha Packers & Movers' },
  ];

  return (
    <div className="gallery">
      <h2 className="gallery-title">Our Work</h2>
      <div className="gallery-grid">
        {images.map((image, index) => (
          <div className="gallery-item" key={index}>
            <img src={image.src} alt={image.alt} className="gallery-image" loading="lazy" />
          </div>
        ))}
      </div>
    </div>
  );
}